import { db } from './firebaseFirestore';
import type { ISponsor } from './components/stores/Sponsor';
import type { IRaffle } from 'react-ui-components/components/models/IRaffle';
import type {
  ContentAssignmentTargetKey,
  ResolvedContentSlots,
} from 'react-ui-components/components/Content/IContentData';
import {
  resolveAssignmentsByScope,
  resolveGlobalAssignments,
} from 'react-ui-components/components/Content/contentAssignments';

export type FeaturedBusinessWithResolvedContent = {
  id: string;
  iconUrl?: string;
  image?: string;
  resolvedContentSlots?: ResolvedContentSlots;
  [key: string]: any;
};

export const resolveRaffleAssignments = async (raffleIds: string[]) =>
  resolveAssignmentsByScope({
    db,
    scopeType: 'raffle',
    scopeIds: raffleIds,
    targetKeys: ['raffle.media', 'raffle.ticket.image'],
  });

export const resolveSponsorAssignments = async (sponsorIds: string[]) =>
  resolveAssignmentsByScope({
    db,
    scopeType: 'sponsor',
    scopeIds: sponsorIds,
    targetKeys: ['sponsor.icon', 'sponsor.header.image'],
  });

export const resolveFeaturedBusinessAssignments = async (featuredBusinessIds: string[]) =>
  resolveAssignmentsByScope({
    db,
    scopeType: 'featuredBusiness',
    scopeIds: featuredBusinessIds,
    targetKeys: ['featuredBusiness.icon', 'featuredBusiness.header.image'],
  });

export const resolveGlobalRichAssignments = async (
  targetKeys: ContentAssignmentTargetKey[],
) => resolveGlobalAssignments({ db, targetKeys });

export const overlayRaffleAssignments = (
  raffle: IRaffle,
  resolvedContentSlots?: ResolvedContentSlots,
): IRaffle => ({
  ...raffle,
  resolvedContentSlots,
  ticketDesign: {
    ...(raffle.ticketDesign || {}),
    ticketImage:
      resolvedContentSlots?.images?.['raffle.ticket.image'] ||
      raffle.ticketDesign?.ticketImage,
  },
});

export const overlaySponsorAssignments = (
  sponsor: ISponsor,
  resolvedContentSlots?: ResolvedContentSlots,
): ISponsor => ({
  ...sponsor,
  resolvedContentSlots,
  iconUrl:
    resolvedContentSlots?.images?.['sponsor.icon'] ||
    sponsor.iconUrl,
  image:
    resolvedContentSlots?.images?.['sponsor.header.image'] ||
    sponsor.image,
});

export const overlayFeaturedBusinessAssignments = (
  featuredBusiness: FeaturedBusinessWithResolvedContent,
  resolvedContentSlots?: ResolvedContentSlots,
): FeaturedBusinessWithResolvedContent => ({
  ...featuredBusiness,
  resolvedContentSlots,
  iconUrl:
    resolvedContentSlots?.images?.['featuredBusiness.icon'] ||
    featuredBusiness.iconUrl,
  image:
    resolvedContentSlots?.images?.['featuredBusiness.header.image'] ||
    featuredBusiness.image,
});
